module.exports = __webpack_public_path__ + "1ab2db2f5453eff68e6f3d2a50b35b49.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/gildan-hooded-zipped-orange.jpg
// module id = 841
// module chunks = 0